import { render, staticRenderFns } from "./WidgetConfigForm.vue?vue&type=template&id=4b2bda7a&scoped=true&"
import script from "./WidgetConfigForm.vue?vue&type=script&lang=ts&"
export * from "./WidgetConfigForm.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetConfigForm.vue?vue&type=style&index=0&id=4b2bda7a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bda7a",
  null
  
)

export default component.exports